const PROMOTED_FLAG = 'data-cmp-promoted';

export class ScriptLoader {
  promote(grantedPurposes) {
    const blocked = [
      ...document.querySelectorAll(`script[type="text/plain"][data-cmp-purpose]`),
      ...(window.__NedawareCmpBlocked || []),
    ];
    for (const node of blocked) {
      if (node.hasAttribute(PROMOTED_FLAG)) continue;
      const purpose = node.getAttribute('data-cmp-purpose');
      if (!grantedPurposes.has(purpose)) continue;

      const fresh = document.createElement('script');
      for (const a of node.attributes) {
        if (a.name === 'type' || a.name === 'data-cmp-purpose' || a.name === 'data-src') continue;
        fresh.setAttribute(a.name, a.value);
      }
      // External scripts blocked by VendorScriptRenderer::external() carry the URL in
      // data-src (a real src would make the browser fetch it). Restore it unless a src exists.
      const deferredSrc = node.getAttribute('data-src');
      if (deferredSrc && !node.hasAttribute('src')) fresh.setAttribute('src', deferredSrc);
      // Copy boolean DOM properties not reflected as HTML attributes in all environments
      if (node.async) fresh.async = true;
      if (node.defer) fresh.defer = true;
      if (!fresh.hasAttribute('src')) fresh.text = node.text;
      fresh.setAttribute(PROMOTED_FLAG, '1');
      node.setAttribute(PROMOTED_FLAG, '1');
      node.parentNode.replaceChild(fresh, node);
    }
  }
}
